// 14 色号数据 —— 逐条抄自已发布文章 docs/seo/articles/braiding-hair-colour-codes/content.html
// 以博客那套为准（只有它们有实物照片）。
// 生成日期：2026-09-26
// 注意：不要从 CSS 反推结构，这里的字段顺序与博客 DOM 一一对应。
window.TFBL_COLOURS = [
  { code: '#1',   name: 'Jet Black',          hex: '#2C282B', img: 'chip-1.webp?v=1789202321'   },
  { code: '#1B',  name: 'Soft Natural Black', hex: '#323132', img: 'chip-1B.webp?v=1789202735'  },
  { code: '#2',   name: 'Dark Brown',         hex: '#382C2A', img: 'chip-2.webp?v=1789202376'   },
  { code: '#4',   name: 'Chocolate Brown',    hex: '#4C362F', img: 'chip-4.webp?v=1789202392'   },
  { code: '#27',  name: 'Honey Blonde',       hex: '#B78B55', img: 'chip-27.webp?v=1789202443'  },
  { code: '#30',  name: 'Copper Brown',       hex: '#87573A', img: 'chip-30.webp?v=1789202465'  },
  { code: '#350', name: 'Copper',             hex: '#B9431C', img: 'chip-350.webp?v=1789202492' },
  { code: '#613', name: 'Platinum Blonde',    hex: '#DAB977', img: 'chip-613.webp?v=1789202507' },
  { code: '#99J', name: 'Wine Burgundy',      hex: '#63323E', img: 'chip-99J.webp?v=1789202862' },
];

// 曲度下拉候选值 —— 取自设计文档 §2.4（合并 corpus/ 里各家的实际用词）
window.TFBL_CURLS = [
  'Deep Wave',
  'Deep Curly',
  'Body Wave',
  'Water Wave',
  'Wet and Wavy',
  'Loose Wave',
  'Burmese Curly',
  'Afro Kinky Curly',
  'Tight Curly',
  'Kinky Straight',
  'Spanish Curl',
  'Messy Curl',
  'Soft Spiral',
];

// 长度区间 —— 对齐 Tressifine 现有变体范围
window.TFBL_LENGTHS = Array.from({ length: 6 }, (_, i) => 16 + i * 2); // 16-26 inch (catalog options 16/18/20/22/24/26)

// 品牌自动补全的预置值（仅方便试填，不构成白名单）
window.TFBL_BRANDS = [
  'Tressifine',
  'Luvme',
  'QVR',
  'lockbraids',
  'lollyhair',
  'eayonhair',
  'heatfreehair',
];

window.TFBL_CDN = 'https://cdn.shopify.com/s/files/1/0731/7887/4071/files/';

(function () {
  'use strict';

  var CDN = window.TFBL_CDN;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var el = {
    brand: document.getElementById('cp-brand'),
    brands: document.getElementById('cp-brands'),
    curl: document.getElementById('cp-curl'),
    length: document.getElementById('cp-length'),
    lengthVal: document.getElementById('cp-length-val'),
    weight: document.getElementById('cp-weight'),
    price: document.getElementById('cp-price'),
    colours: document.getElementById('cp-colours'),
    slot: document.getElementById('cp-card-slot'),
    body: document.getElementById('cp-body'),
    empty: document.getElementById('cp-empty'),
    sort: document.getElementById('cp-sort')
  };

  var rows = [];
  var sortDesc = false;
  var lastPrice = null;
  var hadResult = false;

  /* ── 品牌预置 ───────────────────────────────────── */
  window.TFBL_BRANDS.forEach(function (b) {
    var o = document.createElement('option');
    o.value = b;
    el.brands.appendChild(o);
  });

  /* ── 曲度 ───────────────────────────────────────── */
  (function () {
    var dl = document.getElementById('cp-curls');
    if (!dl) return;
    window.TFBL_CURLS.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c;
      dl.appendChild(o);
    });
  })();

  /* ── 长度横条：step=2 所以只会落在偶数上 ──────────── */
  function syncLengthVal() {
    var len = q('cp-length'), out = q('cp-length-val');
    if (len && out) out.textContent = len.value + '"';
  }
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'cp-length') syncLengthVal();
  });

  /* ── 色卡：radio + figure，保持 .tfbl-colour 语义不变 ── */
  window.TFBL_COLOURS.forEach(function (c) {
    var label = document.createElement('label');
    label.className = 'cp-colour';

    var input = document.createElement('input');
    input.type = 'radio'; input.name = 'cp-colour'; input.value = c.code;

    var fig = document.createElement('figure');
    fig.className = 'tfbl-colour';

    var img = document.createElement('img');
    img.className = 'tfbl-colour-img';
    img.src = CDN + c.img;
    img.width = 520; img.height = 693;
    img.alt = c.name + ' braiding hair, code ' + c.code.replace('#', '') + '.';
    img.loading = 'lazy'; img.decoding = 'async';

    var swatch = document.createElement('i');
    swatch.className = 'tfbl-colour-swatch';
    swatch.style.setProperty('--c', c.hex);

    var cap = document.createElement('figcaption');
    cap.className = 'tfbl-colour-meta';
    [['tfbl-colour-code', c.code], ['tfbl-colour-name', c.name], ['tfbl-colour-hex', c.hex]]
      .forEach(function (pair) {
        var s = document.createElement('span');
        s.className = pair[0]; s.textContent = pair[1];
        cap.appendChild(s);
      });

    fig.appendChild(img); fig.appendChild(swatch); fig.appendChild(cap);
    label.appendChild(input); label.appendChild(fig);

    input.addEventListener('change', function () {
      Array.prototype.forEach.call(el.colours.querySelectorAll('.cp-colour'), function (n) {
        n.classList.remove('is-selected');
      });
      label.classList.add('is-selected');
      render();
    });

    el.colours.appendChild(label);
  });

  /* ── 步进按钮（委托，避免元素被母主题重建后失效）── */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.cp-stepper button') : null;
    if (!btn || !btn.dataset || !btn.dataset.target) return;
    var input = q(btn.dataset.target);
    if (!input) return;
    var step = parseFloat(btn.dataset.step);
    var base = parseFloat(input.value);
    var next = isNaN(base) ? Math.max(0, step) : base + step;
    input.value = next > 0 ? String(Math.round(next * 100) / 100) : '';
    render();
  });

  /* ── 读取输入（每次都实时查询，不缓存 DOM 引用）──────────
     原因：Shopify 母主题会重建 number input，缓存下来的引用会指向死元素。 */
  function q(id) { return document.getElementById(id); }

  function read() {
    var wNode = q('cp-weight'), pNode = q('cp-price');
    var rawW = wNode ? wNode.value.trim() : '';
    var rawP = pNode ? pNode.value.trim() : '';
    var w = parseFloat(rawW);
    var p = parseFloat(rawP);

    var picked = document.querySelector('#cp-colours input[name="cp-colour"]:checked');
    var curlNode = q('cp-curl');

    var brandNode = q('cp-brand'), lenNode = q('cp-length');

    return {
      brand: brandNode ? brandNode.value.trim() : '',
      colour: picked ? picked.value : '',
      curl: curlNode ? curlNode.value.trim() : '',
      length: lenNode ? lenNode.value : '',
      weight: (rawW === '' || isNaN(w) || w <= 0) ? null : w,
      price:  (rawP === '' || isNaN(p) || p <= 0) ? null : p
    };
  }

  function missingReason(d) {
    if (d.weight === null && d.price === null) {
      return { title: 'Two numbers still missing',
               body: 'This tool needs the <b>total weight</b> and the <b>total price</b> of the purchase.' };
    }
    if (d.weight === null) {
      return { title: 'No weight published',
               body: 'This brand hasn\u2019t published a weight for this product. That is common \u2014 11 of the 30 listings we reviewed didn\u2019t state one either. Without grams there is no cost per gram, so there is nothing honest to compare here.' };
    }
    return { title: 'No price entered',
             body: 'Add the <b>total price</b> you would pay for that weight.' };
  }

  function fmtMoney(n) { return '$' + n.toFixed(n >= 0.10 ? 2 : 3); }
  function trimNum(n) { return String(Math.round(n * 100) / 100); }

  /* ── 数字滚动 ───────────────────────────────────── */
  var tickRAF = null;
  function tickTo(node, to) {
    if (reduceMotion || lastPrice === null || lastPrice === to) {
      node.textContent = fmtMoney(to); lastPrice = to; return;
    }
    var from = lastPrice, start = performance.now(), dur = 260;
    if (tickRAF) cancelAnimationFrame(tickRAF);
    (function step(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      node.textContent = fmtMoney(from + (to - from) * eased);
      if (t < 1) { tickRAF = requestAnimationFrame(step); } else { lastPrice = to; }
    })(start);
  }

  /* ── 结果渲染 ───────────────────────────────────── */
  function render(shaking) {
    var d = read();
    var valid = d.weight !== null && d.price !== null;

    if (!valid) {
      var m = missingReason(d);
      var changed = el.slot.dataset.mode !== 'missing' || el.slot.dataset.reason !== m.title;
      el.slot.dataset.mode = 'missing';
      el.slot.dataset.reason = m.title;
      if (changed) {
        el.slot.innerHTML = '<div class="cp-missing" id="cp-missing-el"><b>' + m.title + '</b><br>' + m.body + '</div>';
      }
      if (shaking && !reduceMotion) {
        var box = document.getElementById('cp-missing-el');
        if (box) { box.classList.remove('is-shake'); void box.offsetWidth; box.classList.add('is-shake'); }
      }
      lastPrice = null; hadResult = false;
      return;
    }

    var perGram = d.price / d.weight;
    var packs = d.weight / 100;

    if (el.slot.dataset.mode !== 'result') {
      el.slot.dataset.mode = 'result';
      el.slot.innerHTML =
        '<div class="cp-card" id="cp-card">' +
          '<div class="cp-row-top">' +
            '<div>' +
              '<p class="cp-eyebrow">Cost per gram</p>' +
              '<p class="cp-price"><span id="cp-pergram"></span><small>per gram</small></p>' +
            '</div>' +
            '<p class="cp-eq"><b id="cp-totalw"></b> g total<br><b id="cp-packs"></b> packs at 100 g</p>' +
          '</div>' +
          '<div class="cp-card-foot">' +
            '<button type="button" class="cp-add" id="cp-add"><span class="cp-tick">✓</span>Add to comparison</button>' +
            '<span class="cp-hint" id="cp-hint">Compare against the others below.</span>' +
          '</div>' +
        '</div>';
      lastPrice = null;
      document.getElementById('cp-add').addEventListener('click', onAdd);
    }

    tickTo(document.getElementById('cp-pergram'), perGram);
    document.getElementById('cp-totalw').textContent = trimNum(d.weight);
    document.getElementById('cp-packs').textContent = (Math.round(packs * 10) / 10).toFixed(1);

    if (!hadResult) {
      var card = el.slot.firstChild;
      if (card && !reduceMotion) {
        card.classList.remove('is-enter'); void card.offsetWidth; card.classList.add('is-enter');
      }
      hadResult = true;
    }
  }

  /* ── 加入对比：success check 反馈 ───────────────── */
  var doneTimer = null;
  function onAdd() {
    var d = read();
    if (d.weight === null || d.price === null) { render(true); return; }

    rows.push({
      id: 'r' + Date.now() + Math.random().toString(36).slice(2, 7),
      brand: d.brand || '\u2014',
      colour: d.colour || '\u2014',
      curl: d.curl || '\u2014',
      length: d.length + '"',
      weight: d.weight,
      price: d.price,
      perGram: d.price / d.weight,
      fresh: true
    });
    paint();

    // 按钮短暂变成勾选态（不清空输入 —— 用户常要微调后加第二行）
    var btn = document.getElementById('cp-add');
    if (btn && !reduceMotion) {
      btn.classList.add('is-done');
      if (doneTimer) clearTimeout(doneTimer);
      doneTimer = setTimeout(function () { btn.classList.remove('is-done'); }, 900);
    }
  }

  function del(id) {
    rows = rows.filter(function (r) { return r.id !== id; });
    paint();
  }

  /* ── 表格渲染 + 排序 ────────────────────────────── */
  var sortCol = 'perGram';
  function paint() {
    var sorted = rows.slice().sort(function (a, b) {
      var v = a[sortCol] - b[sortCol];
      return sortDesc ? -v : v;
    });

    el.body.innerHTML = '';
    var best = sorted.length ? sorted[0].perGram : null;

    sorted.forEach(function (r) {
      var tr = document.createElement('tr');
      if (r.fresh && !reduceMotion) tr.classList.add('is-enter');
      r.fresh = false;

      function td(text, cls) {
        var c = document.createElement('td');
        c.textContent = text;
        if (cls) c.className = cls;
        return c;
      }

      tr.appendChild(td(r.brand));
      tr.appendChild(td(r.colour));
      tr.appendChild(td(r.curl));
      tr.appendChild(td(r.length));
      tr.appendChild(td(trimNum(r.weight) + ' g'));
      tr.appendChild(td('$' + trimNum(r.price)));
      tr.appendChild(td(fmtMoney(r.perGram), r.perGram === best ? 'cp-best' : ''));

      var t = document.createElement('td');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cp-del'; b.textContent = '\u00d7';
      b.setAttribute('aria-label', 'Remove ' + r.brand + ' from the comparison');
      b.addEventListener('click', function () { del(r.id); });
      t.appendChild(b);
      tr.appendChild(t);

      el.body.appendChild(tr);
    });

    // 空状态的淡出（hidden 属性 + CSS 过渡）
    el.empty.hidden = sorted.length > 0;
    el.sort.closest('th').setAttribute('aria-sort', sortDesc ? 'descending' : 'ascending');
  }

  el.sort.addEventListener('click', function () { sortDesc = !sortDesc; paint(); });

  /* ── 绑定输入：事件委托 ──────────────────────────────
     为什么不用直接绑定：线上实测发现，Shopify 母主题的 dt-theme.js 会把
     <input type="number"> 改造成数量选择器（class 变 js-qty__num、元素被重建），
     直接 addEventListener 上去的监听会随旧元素一起消失 ——
     表现就是"填了克重和价格但结果区永远停在缺数提示"。
     改用委托后，元素被替换多少次都不影响。 */
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.id) return;
    if (t.id === 'cp-weight' || t.id === 'cp-price' || t.id === 'cp-brand' ||
        t.id === 'cp-curl' || t.id === 'cp-length') {
      if (t.id === 'cp-length') syncLengthVal();
      render();
    }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.id) return;
    if (t.id === 'cp-curl' || t.id === 'cp-length') { render(); return; }
    // 数字框失焦且无效时抖一下
    if (t.id === 'cp-weight' || t.id === 'cp-price') {
      var v = parseFloat(t.value);
      if (t.value.trim() !== '' && (isNaN(v) || v <= 0)) render(true);
    }
  });

  render();
  paint();
})();
